
import { SaleAwsDocument } from "@/models/base/sale-aws-document";
import Vue from "vue";
import {SaleService} from "@/services";
import { Sale } from "@/models/base";

export default Vue.extend({
	data(){
		return {
			doc: new SaleAwsDocument(),
			isSaving: false
		};
	},
	props: {
		value: {
			type: Object as ()=>SaleAwsDocument,
			required: true
		},
		sale: {
			type: Object as ()=>Sale,
			required: true
		},
		saveChanges: Boolean
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async confirm(){
			this.isSaving = true;
			let oldValue = new SaleAwsDocument(this.value);
			this.value.ShowWithPrint = this.doc.ShowWithPrint;
			this.value.ShowWithSend = this.doc.ShowWithSend;
			this.value.ShowWithDownload = this.doc.ShowWithDownload;
			if (this.saveChanges && this.value.ID != 0) {
				try{
					await SaleService.updateDocuments(this.sale, [this.value]);
					this.$emit("close");
				}catch(err){
					this.value.ShowWithPrint = oldValue.ShowWithPrint;
					this.value.ShowWithSend = oldValue.ShowWithSend;
					this.value.ShowWithDownload = oldValue.ShowWithDownload;
				}
			}else{
				this.$emit("close");
			}
			this.isSaving = false;
		}
	},
	mounted(){
		this.doc = new SaleAwsDocument(this.value.getJSON());
	},
	i18nEx: {
		componentPrefix: "components.aws-documents"
	}
});
